/** Header the IMDb GraphQL gateway uses to identify the calling client. */
export const IMDB_CLIENT_NAME_HEADER = 'x-imdb-client-name';

/** Identifies this website to the IMDb GraphQL gateway. */
export const IMDB_CLIENT_NAME = 'imdb-trust-admin';
